import { Container } from '@spark-web/container';
import { Divider } from '@spark-web/divider';
import { PhoneIcon } from '@spark-web/icon';
import { Inline } from '@spark-web/inline';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';
import { TextLink } from '@spark-web/text-link';
import { useApplicationData } from '../../provider';
import { PAGE_FOOTER, getApplicantTypeAndTrackingIdFromUrl } from '../../utils';

export const BrighteContactDetails = () => {
  const { trackingId } = getApplicantTypeAndTrackingIdFromUrl();
  const { APPLY_BY_PHONE, CALL_BRIGHTE, MENTION_CODE } = PAGE_FOOTER;

  return (
    <Stack border="field" padding="xxlarge" gap="xlarge">
      <Inline gap="small" alignY="center">
        <PhoneIcon size="xsmall" tone="primaryActive" />
        <Text size="large" weight="semibold" tone="muted">
          {APPLY_BY_PHONE}
        </Text>
      </Inline>

      {CALL_BRIGHTE}

      <Inline gap="xsmall">
        <Text size="large" tone="muted">
          {MENTION_CODE}
        </Text>
        <Text size="large" weight="semibold" tone="muted">
          {trackingId}
        </Text>
      </Inline>
    </Stack>
  );
};

const Footer = () => {
  const quote = useApplicationData('quote');
  const financialProductId = quote?.financialProduct?.id;
  const {
    WHO_IS_BRIGHTE,
    COMPANY_DESCRIPTION,
    BRIGHTE_BUSINESS_DETAILS,
    BRIGHTE_CAPITAL,
    TERMS_CONDITIONS,
    PRIVACY_POLICY,
    TERMS,
    TERMS_LOANS,
  } = PAGE_FOOTER;

  const TERMS_LINK = TERMS[financialProductId ?? ''] ?? TERMS_LOANS;

  return (
    <Stack background="surfaceMuted" padding="xxlarge">
      <Container size="xlarge">
        <Stack gap="xxlarge">
          <BrighteContactDetails />

          <Stack gap="xlarge">
            <Text weight="semibold" tone="muted">
              {WHO_IS_BRIGHTE}
            </Text>
            <Text tone="muted">{COMPANY_DESCRIPTION}</Text>

            <Divider />

            <Text tone="muted">{BRIGHTE_BUSINESS_DETAILS}</Text>

            <Text weight="semibold" tone="muted">
              {BRIGHTE_CAPITAL}
            </Text>

            <Inline gap="medium">
              <Text tone="muted">
                <TextLink target="_blank" href={TERMS_LINK}>
                  {TERMS_CONDITIONS}
                </TextLink>
              </Text>
              <Text tone="muted">
                <TextLink href="https://brighte.com.au/support/privacy">{PRIVACY_POLICY}</TextLink>
              </Text>
            </Inline>
          </Stack>
        </Stack>
      </Container>
    </Stack>
  );
};

export { Footer };
